module.exports = __webpack_public_path__ + "static/media/o-nama-lexhr.f9956e18.pdf";